<template>
  <div>
  	<router-view></router-view>
  	<BottomSheet></BottomSheet>
  </div>
</template>

<script>
import BottomSheet from './BottomSheet'
import List from './multiview/List'
import EventsEditor from './events/Editor'

export default {
  routes: [
    {
      path: "",
      redirect: "/multiview/list"
    },
    {
      path: "list",
      component: List,
      name: "Multiview list",
    },
    {
      path: "event/:id",
      name: "Multiview edit event",
      components: {
        default: List,
        bottomEditor: EventsEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        new: "New event"
      }
    }
  ],
  components: {
    BottomSheet
  }
}
</script>
